import { defineSlotRecipe } from '@chakra-ui/react';
import { checkboxAnatomy } from '@chakra-ui/react/anatomy';

export default defineSlotRecipe({
  slots: checkboxAnatomy.keys(),
  base: {
    control: {
      _disabled: {
        cursor: 'not-allowed',
      },
      _checked: {
        _hover: {
          bg: 'primary.600',
          borderColor: 'primary.600',
        },
        bg: 'primary.500',
        borderColor: 'primary.500',
      },
      _hover: {
        bg: 'gray.25',
        borderColor: 'primary.500',
      },
      bg: 'white',
      borderColor: 'gray.300',
      cursor: 'pointer',
    },
  },
  variants: {
    variant: {
      solid: {
        control: {
          // apparently chakra doesnt use its own _checked and indeterminate
          // state selectors for some reason, so we have to use the data-state
          // attribute instead
          '&:is([data-state=checked], [data-state=indeterminate])': {
            _hover: {
              bg: 'primary.600',
              borderColor: 'primary.600',
            },
            bg: 'primary.500',
            borderColor: 'primary.500',
          },
          bg: 'white',
          borderColor: 'gray.300',
        },
      },
    },
  },
});
